import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import config from "@/lib/config";
import { errorMessages } from "@/lib/constants";
import { addPaymentInstrument } from "@/lib/mailTemplate";
import sendEmail from "@/lib/sendEmail";
import { gql } from "@apollo/client";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import crypto from "crypto";
import jwt from "jsonwebtoken";
import { isAuthenticated, ownerOnly } from "./helper";
export const typeDef = gql`
  type PaymentInstruments @cacheControl(scope: PRIVATE, maxAge: 0) {
    default_flag: Boolean
    payment_method: PaymentMethod
    payment_method_id: Int
    payment_instrument_id: Int
    ref_id: String
    values: PurchaseMethodsValues
  }

  type PurchaseMethodsValues {
    card_number: String
    card_type: String
    expiry_date: String
  }
  type PaymentMethod {
    name: String
  }

  type PaymentInstrumentsCreateCreditCardRecaptchaV2Result
    @cacheControl(scope: PRIVATE) {
    redirect_link: Boolean
    http_method: String
    redirect_url: String
    form_data: FormData
    charset: String
    error: String
    recaptchaSuccessV2: Boolean
  }

  type PaymentInstrumentsCreateCreditCardRecaptchaV3Result
    @cacheControl(scope: PRIVATE) {
    redirect_link: Boolean
    http_method: String
    redirect_url: String
    form_data: FormData
    charset: String
    error: String
    recaptchaSuccessV3: Boolean
  }

  type PaymentInstrumentsCreateOther @cacheControl(scope: PRIVATE) {
    redirect_link: Boolean
    http_method: String
    redirect_url: String
    form_data: FormData
    charset: String
    error: String
  }

  type FormData {
    pay_method: String
    merchant_id: String
    service_id: String
    cust_code: String
    order_id: String
    item_id: String
    item_name: String
    service_type: Int
    terminal_type: Int
    success_url: String
    cancel_url: String
    error_url: String
    pagecon_url: String
    free1: String
    free2: String
    free3: String
    request_date: String
    limit_second: String
    sps_hashcode: String
  }

  type PaymentInstrumentsActivate @cacheControl(scope: PRIVATE) {
    payment_instrument_id: Int
    error: PaymentInstrumentsActivateError
  }

  type PaymentInstrumentsDeactivate @cacheControl(scope: PRIVATE) {
    payment_instrument_id: Int
    error: PaymentInstrumentsDeactivateError
  }

  type PaymentInstrumentsActivateError @cacheControl(scope: PRIVATE) {
    message: String
  }

  type PaymentInstrumentsDeactivateError @cacheControl(scope: PRIVATE) {
    message: String
  }

  type PaymentInstrumentsSetDefault @cacheControl(scope: PRIVATE) {
    result: Boolean
  }

  type SendMailResult {
    result: Boolean
  }

  type Query {
    paymentInstruments(type: String, scope: String): [PaymentInstruments]
    paymentInstrumentInfo(id: Int): PaymentInstruments
  }

  type Mutation {
    paymentInstrumentsCreateCreditCardRecaptchaV2(
      payment_method_id: Int
      replace_flag: Boolean
      success_url: String
      cancel_url: String
      error_url: String
      token: String
      token_key: String
      tds_info_token: String
      tds_info_token_key: String
      tokenPayload: JSONObject
      recaptchaTokenV2: String
    ): PaymentInstrumentsCreateCreditCardRecaptchaV2Result

    paymentInstrumentsCreateCreditCardRecaptchaV3(
      payment_method_id: Int
      replace_flag: Boolean
      success_url: String
      cancel_url: String
      error_url: String
      token: String
      token_key: String
      tds_info_token: String
      tds_info_token_key: String
      tokenPayload: JSONObject
      recaptchaTokenV3: String
    ): PaymentInstrumentsCreateCreditCardRecaptchaV3Result

    paymentInstrumentsCreateOther(
      payment_method_id: Int
      replace_flag: Boolean
      success_url: String
      cancel_url: String
      error_url: String
      tokenPayload: JSONObject
    ): PaymentInstrumentsCreateOther

    paymentInstrumentsActivate(
      payment_instrument_id: Int
    ): PaymentInstrumentsActivate

    paymentInstrumentsDeactivate(
      payment_instrument_id: Int
    ): PaymentInstrumentsDeactivate

    paymentInstrumentsSetDefault(
      payment_instrument_id: Int
    ): PaymentInstrumentsSetDefault

    addPaymentInstrumentSendMail(paymentInstrumentId: Int): SendMailResult
  }
`;
export const resolvers = composeResolvers({
  Query: {
    paymentInstruments: async (_parent, args, _ref) => {
      let {
        dataSources
      } = _ref;
      try {
        const res = await dataSources.paymentInstruments.getPaymentInstruments(args);
        return res.payment_instruments;
      } catch (e) {
        console.log("getPaymentInstruments error", e);
      }
    },
    paymentInstrumentInfo: async (_parent, _ref2, _ref3) => {
      let {
        id
      } = _ref2;
      let {
        dataSources
      } = _ref3;
      try {
        const res = await dataSources.paymentInstruments.paymentInstrument(id);
        return res.payment_instrument;
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  },
  Mutation: {
    paymentInstrumentsCreateCreditCardRecaptchaV2: async (_parent, args, _ref4) => {
      let {
        req,
        dataSources
      } = _ref4;
      let recaptchaSuccess = false;
      try {
        console.log("########## paymentInstrumentsCreateCreditCardV2 ##########");
        const recaptchaResult = await dataSources.recaptcha.recaptchaVerifyV2(args === null || args === void 0 ? void 0 : args.recaptchaTokenV2);
        recaptchaSuccess = (recaptchaResult === null || recaptchaResult === void 0 ? void 0 : recaptchaResult.success) || false;
        if (!recaptchaSuccess) {
          return {
            error: errorMessages["recaptcha"],
            recaptchaSuccessV2: recaptchaSuccess
          };
        }
        if (recaptchaSuccess) {
          const secret = crypto.createHash("sha256").update(`payment:${req.userToken.id}`).digest("hex");
          const token = jwt.sign(args.tokenPayload, secret);
          const success_url_new = `${args.success_url}?token=${token}`;
          args.success_url = success_url_new;
          const res = await dataSources.paymentInstruments.paymentInstrumentsCreateCreditCard(args);
          console.log("########## paymentInstrumentsCreateCreditCardV2 END ##########");

          // メール送信はsuccess_3dsページで行う

          return _objectSpread(_objectSpread({}, res), {}, {
            recaptchaSuccessV2: recaptchaSuccess
          });
        }
      } catch (e) {
        console.log("PaymentInstrumentsCreateCreditCardV2 error", e);
        const message = errorMessages["paymentRegister"];
        return {
          error: message,
          recaptchaSuccessV2: recaptchaSuccess
        };
      }
    },
    paymentInstrumentsCreateCreditCardRecaptchaV3: async (_parent, args, _ref5) => {
      let {
        req,
        dataSources
      } = _ref5;
      let recaptchaSuccess = false;
      try {
        console.log("########## paymentInstrumentsCreateCreditCardV3 ##########");
        const recaptchaResult = await dataSources.recaptcha.recaptchaVerifyV3(args === null || args === void 0 ? void 0 : args.recaptchaTokenV3);
        recaptchaSuccess = (recaptchaResult === null || recaptchaResult === void 0 ? void 0 : recaptchaResult.score) >= config.reCAPTCHAThresholdV3 || false;
        if (!recaptchaSuccess) {
          return {
            error: errorMessages["recaptcha"],
            recaptchaSuccessV3: recaptchaSuccess
          };
        }
        if (recaptchaSuccess) {
          const secret = crypto.createHash("sha256").update(`payment:${req.userToken.id}`).digest("hex");
          const token = jwt.sign(args.tokenPayload, secret);
          const success_url_new = `${args.success_url}?token=${token}`;
          args.success_url = success_url_new;
          const res = await dataSources.paymentInstruments.paymentInstrumentsCreateCreditCard(args);
          console.log("########## paymentInstrumentsCreateCreditCardV3 END ##########");

          // メール送信はsuccess_3dsページで行う

          // const { user } = await dataSources.user.me();

          return _objectSpread(_objectSpread({}, res), {}, {
            recaptchaSuccessV3: recaptchaSuccess
          });
        }
      } catch (e) {
        console.log("PaymentInstrumentsCreateCreditCardV3 error", e);
        const message = errorMessages["paymentRegister"];
        return {
          error: message,
          recaptchaSuccessV3: recaptchaSuccess
        };
      }
    },
    paymentInstrumentsCreateOther: async (_parent, _ref6, _ref7) => {
      let {
        payment_method_id,
        replace_flag,
        success_url,
        cancel_url,
        error_url,
        tokenPayload
      } = _ref6;
      let {
        req,
        dataSources
      } = _ref7;
      try {
        console.log("########## paymentInstrumentsCreateOther ##########");
        console.log("params", {
          payment_method_id,
          replace_flag,
          success_url,
          cancel_url,
          error_url,
          tokenPayload
        });
        const secret = crypto.createHash("sha256").update(`payment:${req.userToken.id}`).digest("hex");
        const token = jwt.sign(tokenPayload, secret);
        success_url = `${success_url}?token=${token}`;
        const res = await dataSources.paymentInstruments.paymentInstrumentsCreateOther(payment_method_id, replace_flag, success_url, cancel_url, error_url);
        console.log("paymentInstrumentsCreateOther", res);
        console.log("########## paymentInstrumentsCreateOther END ##########");
        return res;
      } catch (e) {
        console.log("PaymentInstrumentsCreateOther error", e);
        const message = errorMessages["paymentRegister"];
        return {
          error: message
        };
      }
    },
    paymentInstrumentsActivate: async (_parent, args, _ref8) => {
      let {
        dataSources
      } = _ref8;
      try {
        const res = await dataSources.paymentInstruments.paymentInstrumentsActivate(args);
        return res.payment_instrument;
      } catch (e) {
        console.log("paymentInstrumentsActivate error");
        throw e;
      }
    },
    paymentInstrumentsDeactivate: async (_parent, args, _ref9) => {
      let {
        dataSources
      } = _ref9;
      try {
        const res = await dataSources.paymentInstruments.paymentInstrumentsDeactivate(args);
        return res.payment_instrument;
      } catch (e) {
        var _e$extensions;
        console.log("paymentInstrumentsDeactivate error");
        const message = e === null || e === void 0 || (_e$extensions = e.extensions) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.response) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.body) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.error) === null || _e$extensions === void 0 ? void 0 : _e$extensions.message;
        return {
          error: {
            message: message
          }
        };
      }
    },
    paymentInstrumentsSetDefault: async (_parent, args, _ref10) => {
      let {
        dataSources
      } = _ref10;
      try {
        const res = await dataSources.paymentInstruments.paymentInstrumentsSetDefault(args);
        return {
          result: true
        };
      } catch (e) {
        console.log("paymentInstrumentsSetDefault error", e);
        return {
          result: false
        };
      }
    },
    addPaymentInstrumentSendMail: async (_parent, _ref11, _ref12) => {
      let {
        paymentInstrumentId
      } = _ref11;
      let {
        req,
        dataSources
      } = _ref12;
      try {
        const {
          payment_instrument: paymentInstrument
        } = await dataSources.paymentInstruments.paymentInstrument(paymentInstrumentId);
        // メール送信
        const {
          user
        } = await dataSources.user.me();
        await sendEmail(addPaymentInstrument({
          address: user.mail_address,
          paymentInstrument: paymentInstrument
        }));
        return {
          result: true
        };
      } catch (e) {
        console.log("add paymentInstrument sendEmail error", e);
        return {
          result: false
        };
      }
    }
  }
}, {
  "Mutation.paymentInstrumentsCreateCreditCardRecaptchaV2": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsCreateCreditCardRecaptchaV3": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsCreateOther": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsDeactivate": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsSetDefault": [isAuthenticated(), ownerOnly()]
});